import timeOffInputStore from "../store/store";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_START_DATE', function setStartDateInStore(startDate: Moment) {
    timeOffInputStore.startDate = startDate.clone();
});
